module.exports = __webpack_public_path__ + "static/media/kyra.2fbe23cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/kyra.jpg
// module id = 743
// module chunks = 0